import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M14.5 6.144 8 1.66 1.5 6.144v7.106c0 .69.56 1.25 1.25 1.25h10.5c.69 0 1.25-.56 1.25-1.25zM16 13.25A2.75 2.75 0 0 1 13.25 16H2.75A2.75 2.75 0 0 1 0 13.25v-7.5a.75.75 0 0 1 .324-.617l7.25-5 .1-.059a.75.75 0 0 1 .752.059l7.25 5A.75.75 0 0 1 16 5.75z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M9.5 11.749c0-.69-.56-1.25-1.25-1.25h-.5c-.691 0-1.25.56-1.25 1.25v2.75h3zm1.5 3.5a.75.75 0 0 1-.75.75h-4.5a.75.75 0 0 1-.75-.75v-3.5a2.75 2.75 0 0 1 2.75-2.75h.5a2.75 2.75 0 0 1 2.75 2.75z"
    }, null, -1)
  ]))]))
}
export default { render: render }